module.exports = __webpack_public_path__ + "static/background-5e9ec6b511ed707dd679adc609a052c5.png";